import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operational',
  templateUrl: './operational.component.html',
  styleUrls: ['./operational.component.less']
})
export class OperationalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
